import { inject, Injectable, Pipe, PipeTransform } from '@angular/core';
import { MediaRecording } from 'src/app/models/media-recording.model';
import { MediaRecordingTranscriptionStatusLabelPipe } from 'src/app/pipes/media-recording-transcription-status-label.pipe';

@Pipe({
  name: 'mediaRecordingTranscriptionBannerLabel',
  standalone: true,
  pure: true,
})
@Injectable({ providedIn: 'root' })
export class MediaRecordingTranscriptionBannerLabelPipe implements PipeTransform {
  private media_recording_transcription_status_label_pipe = inject(MediaRecordingTranscriptionStatusLabelPipe);

  transform(recording: MediaRecording | null | undefined): string {
    if (recording === null || recording === undefined) {
      return '';
    }

    return this.getMediaRecordingTranscriptionBannerLabel(recording);
  }

  private getMediaRecordingTranscriptionBannerLabel(recording: MediaRecording): string {
    if (recording.transcription_status === 'processing') {
      return 'Transcribiendo audio…';
    }

    if (recording.transcription_status === 'pending') {
      return 'Transcripción en cola…';
    }

    return this.media_recording_transcription_status_label_pipe.transform(recording.transcription_status) || 'Transcripción';
  }
}
